const workshopATC = document.querySelectorAll(".add-to-cart-btn");

workshopATC.forEach(btn => {
    btn.addEventListener("click", async (e) => {
        e.preventDefault();

        const selectedProductId = btn.dataset.id;
        if(!selectedProductId) return;
        btn.value = "Adding...";
        btn.disabled = true;
    
        try {
          const addRes = await fetch('/cart/add.js?sections=cart-icon-bubble,cart-drawer', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: selectedProductId,
              quantity: 1,
            }),
          });
          console.log(addRes)
          const addData = await addRes.json(); // ✅ parse once
          // ✅ Update cart bubble
          if (addData.sections && addData.sections["cart-icon-bubble"]) {
            const bubbleWrapper = document.querySelector('#cart-icon-bubble');
            if (bubbleWrapper) {
              bubbleWrapper.innerHTML = addData.sections["cart-icon-bubble"];
            }
          }
          // ✅ Update cart drawer
          if (addData.sections && addData.sections["cart-drawer"]) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = addData.sections["cart-drawer"];
            const newDrawer = tempDiv.querySelector('cart-drawer');
            const existingDrawer = document.querySelector('cart-drawer');
            if (newDrawer && existingDrawer) {
              existingDrawer.replaceWith(newDrawer);
              setTimeout(() => {
                const trapTarget = document.querySelector('cart-drawer');
                if (typeof trapFocus === 'function') trapFocus(trapTarget);
              }, 0);
            }
            document.querySelector('cart-drawer')?.classList.add('active');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
        }finally {
            btn.value = "ADD TO CART";
            btn.disabled = false;
        }
    });
});